
<app-breadcrumbs [title]="'MENU.ADMINISTRATION.EXCEPTION_LOGS'" [first]="'MENU.ADMINISTRATION.EXCEPTION_LOGS'" [url]="'/exception-logs'" [id]="breadcrumbsId"></app-breadcrumbs>


<div class="btn-container">
    <dx-button *ngIf="formData?.loggedUser" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="user" [text]="'EXCEPTION-LOGS.VIEW-USER' | translate" (onClick)="viewUser()"></dx-button>
    <dx-button class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="chevrondoubleright" [text]="'ENUMS.EXCEPTION-LOGS.IGNORE' | translate" type="default" (onClick)="changeToIgnore($event)"></dx-button>
    <dx-button class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="chevrondoubleright" [text]="'ENUMS.EXCEPTION-LOGS.IN_PROGRESS' | translate" type="danger" (onClick)="changeToInProgress($event)"></dx-button>
    <dx-button class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="chevrondoubleright" [text]="'ENUMS.EXCEPTION-LOGS.RESOLVED' | translate" type="success" (onClick)="changeToResolved($event)"></dx-button>
</div>

<div class="row">
    <div class="col-md-4 col-sm-12 col-xs-12">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item itemType="group">
                <dxi-item dataField="type" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.TYPE' | translate"></dxo-label>
                </dxi-item>
                
                <dxi-item dataField="loggedUser" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.USER-CREATED-ID' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="loggedUserName" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.USER-CREATED-NAME' | translate"></dxo-label>
                </dxi-item>

                <dxi-item dataField="className" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.CLASS-NAME' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="url" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.URL' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="causeDescription" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.CAUSE-DESCRIPTION' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.DESCRIPTION' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="requestParams" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.REQUEST-PARAMS' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="requestBody" editorType="dxTextArea" [editorOptions]="{ autoResizeEnabled: true, readOnly: true }">
                    <dxo-label location="top" alignment="left" [text]="'EXCEPTION-LOGS.REQUEST-BODY' | translate"></dxo-label>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>


    <div class="col-md-8 col-sm-12 col-xs-12">
        <dx-tab-panel #tabPanel class="form-panel" [dataSource]="tabs" [selectedIndex]="0" [loop]="false" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{'SHARED.' + tab | translate}}</span>
            </div>
            <div *dxTemplate="let tab of 'item'">
                <dx-data-grid #table 
                    [dataSource]="stackTrace"
                    keyExpr="stack"
                    [rowAlternationEnabled]="false"
                    [showBorders]="true"
                    [showRowLines]="false" 
                    [showColumnLines]="false"
                    [columnAutoWidth]="true"
                    [allowColumnResizing]="false"
                    [hoverStateEnabled]="true"
                [allowColumnResizing]="true"
[allowColumnReordering]="true"
                columnResizingMode="nextColumn">

                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    
                    <dxi-column dataField="ordinal" dataType="string" [allowFiltering]="false" sortOrder="asc" [allowSorting]="true" [width]="150" [caption]="'EXCEPTION-LOGS.ORDINAL' | translate"></dxi-column>
                    <dxi-column dataField="stack" dataType="string" cellTemplate="stackTemplate" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>
                    
                    <div *dxTemplate="let template of 'stackTemplate'">
                        <span [ngClass]="{'text-bold': template.data.stack.startsWith('ba.wms') || template.data.stack.startsWith('ba.eurobit')}">{{ template.data.stack }}</span>
                    </div>

                </dx-data-grid>
            </div>
        </dx-tab-panel>
    </div>

</div>
